import api from './api';

export const clubService = {
  // Obtener todos los clubs (solo super admin) o redirigir al club del usuario
  getClubs: async () => {
    const response = await api.get('/clubs');
    return response.data;
  },

  // Obtener un club específico
  getClub: async (id) => {
    const response = await api.get(`/clubs/${id}`);
    return response.data;
  },

  // Crear un nuevo club (solo super admin)
  createClub: async (clubData) => {
    const formData = new FormData();
    
    // Agregar todos los campos al FormData
    Object.keys(clubData).forEach(key => {
      if (key === 'logo' && clubData[key] instanceof File) {
        formData.append('logo', clubData[key]);
      } else if (key !== 'logo' && clubData[key] !== null && clubData[key] !== undefined) {
        formData.append(key, clubData[key]);
      }
    });

    const response = await api.post('/clubs', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Actualizar un club
  updateClub: async (id, clubData) => {
    const formData = new FormData();
    
    // Agregar todos los campos al FormData
    // IMPORTANTE: Incluir todos los campos, incluso si están vacíos, para que se actualicen correctamente
    Object.keys(clubData).forEach(key => {
      const value = clubData[key];
      if (key === 'logo' && value instanceof File) {
        formData.append('logo', value);
      } else if (key !== 'logo') {
        // Incluir todos los campos, incluso si son null, undefined o string vacío
        // Esto asegura que se envíen al backend para actualización
        const valueToSend = value !== null && value !== undefined ? value : '';
        formData.append(key, valueToSend);
      }
    });

    // Usar POST con _method=PUT para evitar problemas con FormData y PUT
    // Laravel maneja mejor FormData con POST que con PUT
    formData.append('_method', 'PUT');
    
    const response = await api.post(`/clubs/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Eliminar un club (solo super admin)
  deleteClub: async (id) => {
    const response = await api.delete(`/clubs/${id}`);
    return response.data;
  }
};
